import { render, staticRenderFns } from "./AuditoriaTurmas.vue?vue&type=template&id=16cde02c"
import script from "./AuditoriaTurmas.vue?vue&type=script&lang=js"
export * from "./AuditoriaTurmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports